<!-- Mini Portal -->
<div class="agent-portal-mobile-adjustments">

  <!-- spinner -->
  <div class="spinner-wrapper text-center mini-portal-agent-app-spinner" [ngClass]="{'show': loadingAgentApplications || processing || startNewApp}">
    <mat-progress-spinner [mode]="'indeterminate'" role="progressbar" aria-label="progressbar" id="progressbar" aria-labelledby="progressbar"></mat-progress-spinner>
  </div>
  <!-- /spinner -->

  <div class="agent-portal-content-spacing portal-mobile-view">
    <primary-link-component class="mobile-plc" (click)=" goToDemoWelcome() " onkeypress="goToDemoWelcome()"></primary-link-component>
    <h1 class="agent-portal-title agent-portal-hide-on-mobile">John Hancock eApp Portal</h1>
    <h3 class="agent-portal-title  mobile-content">John Hancock eApp Portal</h3>
  </div>

  <div class="agent-portal-content-spacing portal-mobile-view">
    <div>
        <p class="agent-portal-subcopy">
          Welcome, {{ agentName }}!
        </p>

        <p class="agent-portal-subcopy agent-portal-content-spacing">
          Use the "In progress" tab, below, to resume
          an existing application, send the application to the proposed insured,
          and confirm outstanding signatures.
        </p>

        <p class="agent-portal-subcopy agent-portal-content-spacing">
          The "Submitted eApplications" tab provides a snapshot of eApp
          cases you recently submitted. Please use
          <a [href]="JH_NEW_BUSINESS_CASE_URL" target="blank" class="jh-font-family" >New Business Case Status</a> 
          or your usual pending case status tools to track information
          related to underwriting decisions, outstanding requirements,
          and other case details.
        </p>
  </div>

  <div class="two-btn-wrapper agent-portal-content-spacing">
    <button (click)="startNewApplication()"  class="primary-cta-btn jh-font-family">Start a new case</button>
    <button (click)="openIllustrationLink()" class="secondary-cta-btn jh-font-family">Run an illustration</button>
  </div>

  <div class="agent-portal-tab-group agent-portal-content-spacing">
    <div 
      [ngClass]="this.selectedTable === 0 ? 'agent-portal-tab-selected' : 'agent-portal-tab'"
      (click)="showApplications(0)" onkeypress="showApplications(0)"
    >
      In progress
    </div>
    <div 
      [ngClass]="this.selectedTable === 1 ? 'agent-portal-tab-selected' : 'agent-portal-tab'"
      (click)="showApplications(1)" onkeypress="showApplications(1)"
    >
      Submitted
   </div>
  </div>

  <div class="agent-portal-wrapper" [@enterAnimation]>
    <div class="agent-portal-applications-table">
      <!-- In progress-->
      <div *ngIf="this.selectedTable === 0 && this.inProgressApplications" class="table-row-color-alternate">
        <div class="agent-portal-applications-table-top-bar no-show-mobile">
          <div class="applications-table-cell-1">Applicant</div>
          <div class="applications-table-cell-2 hide-on-tablet">Application Start Date</div>
          <div class="applications-table-cell-3 hide-on-tablet">Sections Complete</div>
          <div class="applications-table-cell-4 hide-on-tablet">Agent E-Sign</div>
          <div class="applications-table-cell-5">Customer E-Sign</div>
          <div class="applications-table-cell-6">Last Updated</div>
          <div class="applications-table-cell-7">Actions</div>
        </div>
        
        <div class="agent-portal-applications-table-content app-content" *ngFor="let app of this.inProgressApplications[this.tableIndex]; trackBy: trackByApplicationId">
          <div class="applications-table-cell-1"> {{ app.FirstName }} {{app.LastName}}  </div>
          <div class="applications-table-cell-2 hide-on-tablet">{{ app.CreatedDateTime_ISO  | date: 'MM/dd/yyyy'}}</div>
          <div class="applications-table-cell-3 hide-on-tablet">{{  app.TotalBlocksProgressed/app.TotalNumBlocksThisAppDef | percent:'2.0-2' }}</div>
          <div class="applications-table-cell-4 hide-on-tablet" *ngIf="app.AgentSigned === 1">Yes</div>
          <div class="applications-table-cell-4 hide-on-tablet" *ngIf="app.AgentSigned === 0">No</div>
          <div class="applications-table-cell-5" *ngIf="(app.CustomerSigned === 1 && app.insuredSoleOwner) || (app.CustomerSigned === 1 && !app.OwnershipSignatories)">Yes</div>
          <div class="applications-table-cell-5" *ngIf="(app.CustomerSigned === 0 && app.insuredSoleOwner) || (app.CustomerSigned === 0 && !app.OwnershipSignatories)">No</div> 
          <div class="applications-table-cell-5" *ngIf="!app.insuredSoleOwner && app.OwnershipSignatories">
            
            <a (click)="openSignatorsModal($event,app)" class="unlock-action-item unlock-tertiary-override" style="text-decoration: underline;">
              {{ app.signedSignators }} of {{app.totalSignators}} signed
            </a>
           </div>
          <div class="applications-table-cell-6" *ngIf="app.EmailLogs && app.EmailLogs.length >= 1">
            <div class="action-items-last-sent" style="align-items: flex-start;">
              {{app.LastUpdated | date: 'MM/dd/yyyy' }}
              <div class="last-sent-text" [hidden]="!app.EmailLogs[app.EmailLogs.length -1].created_at" *ngIf="app.CustomerEmailSent && app.EmailLogs[app.EmailLogs.length -1].created_at">
                Sent to proposed insured {{app.EmailLogs[app.EmailLogs.length -1].created_at | date: 'MM/dd/yyyy'}}
              </div>
            </div>
          </div>
          <div class="applications-table-cell-6" *ngIf="!app.EmailLogs">
               {{app.LastUpdated | date: 'MM/dd/yyyy' }}
          </div>
          <div class="applications-table-cell-7">
            <div class="action-items-primary" *ngIf="app.CustomerSigned !== 1">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
              <!-- <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="!app.CustomerEmailSent">Send</button> -->
              <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="app.CustomerEmailSent">Resend</button>
            </div>
            <div class="action-items-primary-full" *ngIf="app.CustomerSigned === 1">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
              <!-- <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="!app.CustomerEmailSent">Send</button> -->
              <!-- <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="app.CustomerEmailSent">Resend</button> -->
              <div class="tertiary-cta-action-item">
                <lock-svg-component class="unlock-svg" (click)="unlockApplication($event,app)" onkeypress="unlockApplication($event,app)"></lock-svg-component>
                <a (click)="unlockApplication($event,app)" class="unlock-action-item unlock-tertiary-override" style="text-decoration: underline;">
                  Unlock to edit
                </a>
              </div>
            </div>
            <!-- <div class="action-item-primary"  *ngIf="app.TotalBlocksProgressed < 19">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
            </div> -->
          </div>
        </div>
      </div>
  
      <!-- Submitted-->
      <div *ngIf="this.selectedTable === 1 && this.submittedApplications">
        <div class="agent-portal-applications-table-top-bar">
          <div class="applications-table-cell-1">Applicant</div>
          <div class="applications-table-cell-2">Application Start Date</div>
          <div class="applications-table-cell-3">Date Submitted</div>
          <div class="applications-table-cell-4">Status</div>
        </div>
        
        <div class="agent-portal-applications-table-content app-content" *ngFor="let app of this.submittedApplications[this.tableIndex]; trackBy: trackByApplicationId">
          <div class="applications-table-cell-1"> {{ app.FirstName }} {{app.LastName}}  </div>
          <div class="applications-table-cell-2">{{ app.CreatedDateTime_ISO  | date: 'MM/dd/yyyy'}}</div>
          <div class="applications-table-cell-3">{{ app.FinalResultsCreatedDateTime  | date: 'MM/dd/yyyy'}}</div>
          <div class="applications-table-cell-4" *ngIf="app.ExportTriagePathName  === 'Incomplete' ">
            <ng-template #inProgressPopover>
              <p class="inProgressMsg">
                In progress cases means your application is being reviewed
                If the status does not update within 48 hours, please contact
                <a  class="inProgressLink" href="mailto:JH_eService@jhancock.com"> JH_eService@jhancock.com </a>
              </p>
            </ng-template>
            <a  href="#" (click)="$event.preventDefault()" tabindex="-1" [ngbPopover]="inProgressPopover" triggers="focus hover" class="inProgressHoverText">
              In Progress
            </a>
          </div>
          <div class="applications-table-cell-4" *ngIf="app.ExportTriagePathName  === 'STP' ">Approved</div>
          <div class="applications-table-cell-4" *ngIf="app.ExportTriagePathName  === 'STP - Validation' ">In Underwriting Review</div>
          <div class="applications-table-cell-4" *ngIf="app.ExportTriagePathName  === 'FUW' "> Full Underwriting</div>
        </div>
      </div>
    </div>

    <!-- Mobile In Progress-->
    <div class="mobile-content mobile-content-wrapper">
      <div *ngIf="this.selectedTable === 0 && this.inProgressApplications" class="table-row-color-alternate">
        <mat-card class=" mobile-card agent-portal-content-spacing" *ngFor="let app of this.inProgressApplications[this.tableIndex]; trackBy: trackByApplicationId">
          <mat-card-content>
              <div class='card-content'>
                <div>
                  <h2 class="jh-font-family"> {{ app.FirstName }} {{app.LastName}} </h2>
                </div>
                <div class="jh-font-family">
                    Last Updated: {{app.LastUpdated | date: 'MM/dd/yyyy' }}
                </div>
                <div class="jh-font-family" *ngIf="(app.CustomerSigned === 1 && app.insuredSoleOwner) || (app.CustomerSigned === 1 && !app.OwnershipSignatories)">Customer E-Sign: Yes</div>
                <div class="jh-font-family" *ngIf="(app.CustomerSigned === 0 && app.insuredSoleOwner) || (app.CustomerSigned === 0 && !app.OwnershipSignatories)">Customer E-Sign: No</div> 
                <div class="jh-font-family" *ngIf="!app.insuredSoleOwner && app.OwnershipSignatories">
                  Customer E-Sign: <a (click)="openSignatorsModal($event,app)" style="border-bottom: 1px solid #0000C1;">
                    <b>{{ app.signedSignators }} of {{app.totalSignators}} signed</b>
                  </a>
                 </div>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div class="action-items-primary" *ngIf="app.CustomerSigned !== 1">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
              <!-- <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="!app.CustomerEmailSent">Send</button> -->
              <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="app.CustomerEmailSent">Resend</button>
            </div>
            <div class="action-items-primary-full" *ngIf="app.CustomerSigned === 1">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
              <!-- <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="!app.CustomerEmailSent">Send</button> -->
              <button class="secondary-cta-btn-action-item" (click)="sendThisApplication($event,app.Id, app.EmailAddress, app.FirstName, app.LastName)" *ngIf="app.CustomerEmailSent">Resend</button>
              <div class="tertiary-cta-action-item"  *ngIf="app.CustomerSigned == 1">
                <lock-svg-component class="unlock-svg" (click)="unlockApplication($event,app)" onkeypress="unlockApplication($event,app)"></lock-svg-component>
                <a (click)="unlockApplication($event,app)" class="unlock-action-item unlock-tertiary-override" style="text-decoration: underline;">
                  Unlock to edit
                </a>
              </div>
            </div>
            <!-- <div class="action-item-primary"  *ngIf="app.TotalBlocksProgressed < 19">
              <button class="primary-cta-btn-action-item"  (click)="resumeApplication(app)">Resume</button>
            </div> -->
          </mat-card-actions>
       </mat-card>
      </div>

      <!-- Mobile Submitted-->
      <div *ngIf="this.selectedTable === 1 && this.submittedApplications" class="table-row-color-alternate">
        <mat-card class=" mobile-card agent-portal-content-spacing" *ngFor="let app of this.submittedApplications[this.tableIndex]; trackBy: trackByApplicationId">
          <mat-card-content>
           <div class='card-content'>
            <div>
              <h2 class="jh-font-family"> {{ app.FirstName }} {{app.LastName}} </h2>
            </div>
            <div class="jh-font-family">
              Application Start Date: {{app.LastUpdated | date: 'MM/dd/yyyy' }}
            </div>
            <div class="jh-font-family">
              Application Start Date: {{app.LastUpdated | date: 'MM/dd/yyyy' }}
            </div>
            <div class="jh-font-family" *ngIf="app.ExportTriagePathName  === 'Incomplete' ">
              <ng-template #inProgressPopover>
                <p class="inProgressMsg">
                  In progress cases means your application is being reviewed
                  If the status does not update within 48 hours, please contact
                  <a  class="inProgressLink" href="mailto:JH_eService@jhancock.com"> JH_eService@jhancock.com </a>
                </p>
              </ng-template>
              <a href="#" (click)="$event.preventDefault()" tabindex="-1" [ngbPopover]="inProgressPopover" triggers="focus hover" class="inProgressHoverText">
                In Progress
              </a>
            </div>
            <div class="jh-font-family" *ngIf="app.ExportTriagePathName  === 'STP' ">Approved</div>
            <div class="jh-font-family" *ngIf="app.ExportTriagePathName  === 'STP - Validation' ">In Underwriting Review</div>
            <div class="jh-font-family" *ngIf="app.ExportTriagePathName  === 'FUW' ">Full Underwriting</div>
           </div>
          </mat-card-content>
       </mat-card>
      </div>
    </div>

    <div class="agent-portal-content-spacing" *ngIf="this.selectedTable === 0 && this.inProgressApplications && this.inProgressApplications.length >= 1">
      <div class="agent-portal-paginator">

          <div class='agent-portal-paginator-item-no-box' *ngIf="this.selectedTable === 0 && this.inProgressApplications && this.inProgressApplications.length > 1">
            <i class="fas fa-angle-left" [ngClass]="this.tableIndex !== 0 ? 'enabled-paginator-icon paginator-icon' : 'disabled-paginator-icon paginator-icon'" (click)="this.tableIndex !== 0 ? this.transitionWithNavButtons('backward', this.selectedTable) : null" onkeypress="this.tableIndex !== 0 ? this.transitionWithNavButtons('backward', this.selectedTable) : null"></i>
          </div>

          <div *ngFor="let indexObject of tableIndeces">
            <div *ngIf="indexObject[0] !== '...' && indexObject[0] !== this.lastIndexBeforeElipses" (click)="this.goToPaginationIndex(indexObject[1])" onkeypress="this.goToPaginationIndex(indexObject[1])" [ngClass]="this.tableIndex === indexObject[1] ? 'agent-portal-paginator-item-selected' : 'agent-portal-paginator-item'">
              {{indexObject[0]}}
            </div>

            <div *ngIf="indexObject[0] === this.lastIndexBeforeElipses" (click)="this.goToPaginationIndex(indexObject[1])" onkeypress="this.goToPaginationIndex(indexObject[1])" [ngClass]="this.tableIndex === indexObject[1] ? 'agent-portal-paginator-item-selected' : 'agent-portal-paginator-item'">
              {{this.lastIndexBeforeElipses}}
            </div>

            <div *ngIf="indexObject[0] === '...'" class="elipses-paginator-item">
              {{indexObject[0]}}
            </div>
          </div>

          <div class='agent-portal-paginator-item-no-box' *ngIf="this.selectedTable === 0 && this.inProgressApplications && this.inProgressApplications.length > 1">
            <i class="fas fa-angle-right" [ngClass]="this.tableIndex !== this.lastIndexAfterElipses - 1 ? 'enabled-paginator-icon paginator-icon' : 'disabled-paginator-icon paginator-icon'" (click)="tableIndex !== this.lastIndexAfterElipses  ? this.transitionWithNavButtons('forward', this.selectedTable) : null" onkeypress="tableIndex !== this.lastIndexAfterElipses  ? this.transitionWithNavButtons('forward', this.selectedTable) : null"></i>
          </div>
      </div>
    </div>

    <div class="agent-portal-content-spacing" *ngIf="this.selectedTable === 1 && this.submittedApplications && this.submittedApplications.length >= 1 ">
      <div class="agent-portal-paginator">
         
        <div class='agent-portal-paginator-item-no-box' *ngIf="this.selectedTable === 1 && this.submittedApplications && this.submittedApplications.length > 1 ">
          <i class="fas fa-angle-left" [ngClass]="this.tableIndex !== 0 ? 'enabled-paginator-icon paginator-icon' : 'disabled-paginator-icon paginator-icon'" (click)="this.tableIndex !== 0 ? this.transitionWithNavButtons('backward', this.selectedTable) : null" onkeypress="this.tableIndex !== 0 ? this.transitionWithNavButtons('backward', this.selectedTable) : null"></i>
        </div>

        <div *ngFor="let indexObject of tableIndeces">
          <div *ngIf="indexObject[0] !== '...' && indexObject[0] !== this.lastIndexBeforeElipses" (click)="this.goToPaginationIndex(indexObject[1])" onkeypress="this.goToPaginationIndex(indexObject[1])" [ngClass]="this.tableIndex === indexObject[1] ? 'agent-portal-paginator-item-selected' : 'agent-portal-paginator-item'">
            {{indexObject[0]}}
          </div>
          <div *ngIf="indexObject[0] === this.lastIndexBeforeElipses" (click)="this.goToPaginationIndex(indexObject[1])" onkeypress="this.goToPaginationIndex(indexObject[1])" [ngClass]="this.tableIndex === indexObject[1] ? 'agent-portal-paginator-item-selected' : 'agent-portal-paginator-item'">
            {{this.lastIndexBeforeElipses}}
          </div>
          <div *ngIf="indexObject[0] === '...'" class="elipses-paginator-item">
            {{indexObject[0]}}
          </div>
        </div>
          
        <div class='agent-portal-paginator-item-no-box' *ngIf="this.selectedTable === 1 && this.submittedApplications && this.submittedApplications.length > 1 ">
          <i class="fas fa-angle-right" [ngClass]="this.tableIndex !== this.lastIndexAfterElipses - 1 ? 'enabled-paginator-icon paginator-icon' : 'disabled-paginator-icon paginator-icon'" (click)="tableIndex !== this.lastIndexAfterElipses  ? this.transitionWithNavButtons('forward', this.selectedTable) : null" onkeypress="tableIndex !== this.lastIndexAfterElipses  ? this.transitionWithNavButtons('forward', this.selectedTable) : null"></i>
        </div>

      </div>
    </div>

  </div>
 
</div>
